import { ChevronDown } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconChevronDown(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ChevronDown />
    </IconWrapper>
  );
}
